<template>
  <v-col v-bind="{ ...containerProps, ...containerOptions }">
    <v-textarea
      v-model="modelValue"
      v-bind="$attrs"
      :color="colors.base"
      :hide-details="!$attrs.hint"
      :persistent-hint="persist"
      rows="1"
      auto-grow
      placeholder=" "
    >
      <template #label>
        <b :class="colors.text">{{ chapter }}</b>
        {{ $attrs.label }}
      </template>
    </v-textarea>
  </v-col>
</template>

<script>
import { EventBus } from '@/utils';

export default {
  name: 'HelmiTextArea',

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    propertyValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    defaultValue: '',
    modelValue: '',
  }),

  computed: {
    label() {
      return `${this.chapter} ${this.$attrs.label}`;
    },

    persist() {
      return this.$attrs.hint && typeof this.$attrs.hint === 'string';
    },
  },

  watch: {
    // Handles internal model changes.
    modelValue(newVal) {
      this.$emit('input', newVal);
      this.$emit('evaluate', newVal, this.$attrs.id);
    },

    // Handles external model changes.
    '$attrs.value': {
      handler(val) {
        this.modelValue = val;
      },
      immediate: true,
    },
  },

  mounted() {
    EventBus.$on('FORM_RESET', this.resetValue);
  },

  methods: {
    resetValue() {
      this.modelValue = this.propertyValue || this.defaultValue;
    },
  },
};
</script>
